export default {
  apiBasePath: '/api/v1',
}